<template>
    <v-icon color="grey-darken-1" :dense="dense" class="mx-1">
        delete
    </v-icon>
</template>

<script>
    export default {
        name: 'DeleteIcon',

        props: {
            dense: {
                type: Boolean,
                default: false
            }
        },
    }
</script>

<style scoped>

</style>